import { Link } from "react-router-dom";
import { ThemeToggle } from "@/components/ThemeToggle";

const LINKS = [
  { label: "Money Flow", href: "#money-flow" },
  { label: "Privacy", href: "#privacy" },
  { label: "Apps", href: "#apps" },
];

export function LandingNav() {
  return (
    <header className="sticky top-0 z-50 border-b border-border/70 bg-background/80 backdrop-blur-xl">
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
        <Link to="/" className="flex items-center gap-2.5">
          <span className="h-3.5 w-3.5 rounded-full bg-primary" />
          <span className="text-xl font-bold tracking-tight text-foreground">
            Budge<span className="text-primary-text">AI</span>
          </span>
        </Link>

        <div className="hidden items-center gap-9 md:flex">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} className="text-sm font-medium text-muted-foreground transition-colors hover:text-foreground">
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2 sm:gap-3">
          <ThemeToggle />
          <Link to="/auth" className="hidden text-sm font-semibold text-foreground sm:inline-block">
            Log in
          </Link>
          <Link
            to="/auth?tab=signup"
            className="rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground shadow-sm transition-transform hover:scale-[1.03] active:scale-[0.98]"
          >
            Get started
          </Link>
        </div>
      </nav>
    </header>
  );
}
